import { styled } from '@mui/material';

export const LogoImage = styled('img')`
  width: 110px;
`;
